import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { USER_MGMT_CNST } from '../../constants/proj.cnst';
import { UM_TABLE_CNST } from '../../constants/table.cnst';
import { DeleteComponent } from '../../modules/shared/components/delete/delete.component';
import { AppStateService } from '../../services/app-state.service';

import { CommonService } from '../../services/common.service';
import { EnvService } from '../../services/env.service';
import { HttpService } from '../../services/http.service';
import { UtilsService } from '../../services/utils.service';


@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss']
})
export class ApplicationsComponent implements OnInit {

  tableConfig: any = {}
  tableData: any = [];

  dataTypes = UM_TABLE_CNST.CLICKABLE_DATA_TYPE;
  modalData: any = [];
  actionNameMapping: any = USER_MGMT_CNST.ACTION_NAME_MAPPING;
  loading: boolean = true;
  viewOnly: boolean = true;

  constructor(
    private modal: NgbModal,
    private commonSrv : CommonService,
    private httpSrv: HttpService,
    private utilSrv: UtilsService,
    private envService : EnvService,
    private router: Router,
    private appStateSrv: AppStateService
  ) { }
    displayedColumns: string[] = ["applicationName", "apis", "urls", "dashboards", "widgets"]

 expanded = new Map<string, boolean>();
  searchTerms = new Map<string, string>();

  getFiltered(items: any[] = [], key: string) {
    const term = (this.searchTerms.get(key) || '').toLowerCase();
    return items.filter(i =>
      i.resourceName.toLowerCase().includes(term) ||
      (this.actionNameMapping[i.resourceActionName] || i.resourceActionName)
        .toLowerCase().includes(term)
    );
  }


  toggle(key: string) {
    this.expanded.set(key, !this.expanded.get(key));
  }

  ngOnInit() {
    this.setTableConfig();
    this.setTableData();
    this.checkuserPermision()
  }

  checkuserPermision(){
    const permissions = this.appStateSrv.getUserPermissions();
    if(permissions && permissions[USER_MGMT_CNST.CURRENT_APPLICATION] && 
      permissions[USER_MGMT_CNST.CURRENT_APPLICATION]['resources'] && 
      permissions[USER_MGMT_CNST.CURRENT_APPLICATION]['resources']['APPLICATION'] &&
      permissions[USER_MGMT_CNST.CURRENT_APPLICATION]['resources']['APPLICATION'].actions.includes('EDIT')) {
        this.viewOnly = false;
    }
  }


  setTableConfig() {
    this.tableConfig = this.commonSrv.setTableConfig('applicationlist')
  }

  setTableData() {
    this.loading = true;
    this.httpSrv.makeGetApiCall('FETCH_ALL_RESOURCES_UNDER_RESOURCE_TYPE', this.envService.product_baseUrl).subscribe({
      next: (response: any) => {
        let appData = response;
        let applications = Object.keys(appData);
        let tableData = applications.map(app=> {
          let data = {
            applicationName: app,
            resources: appData[app]
          }
          return data
        });
        this.tableData = tableData;
        this.loading = false;
      },
      complete: () => {},
      error: () => {
        this.utilSrv.showToastMessage("Failed to fetch applications list", "error");
        this.loading = false;
      }
    });
  }

  assignResource(data: any,type: any){
    this.appStateSrv.setApplicationData({info:data,type: type});
    this.router.navigate(['um','applications','assignResource']);
  }

  handleOptionClick(e: any) {
    let rowData = e.data;

    if (e.val == USER_MGMT_CNST.OPTIONS.VIEW) {
      this.modalData.name = rowData[0] ? rowData[0]['values'][0] : '-'
      this.modalData.desc = rowData[1] ? rowData[1]['values'][0] : '-'
      this.modalData.url = rowData[2] ? rowData[2]['values'][0] : '-'
      this.modalData.status = rowData[3] ? rowData[3]['values'][0] : '-'
}else if (e.val == USER_MGMT_CNST.OPTIONS.DELETE) {
      const modalRef = this.modal.open(DeleteComponent, USER_MGMT_CNST.DELETE_POPUP_OPTIONS);
    }else {
      this.modalData.name = rowData[0] ? rowData[0]['values'][0] : '-'
      this.modalData.desc = rowData[1] ? rowData[1]['values'][0] : '-'
      this.modalData.url = rowData[2] ? rowData[2]['values'][0] : '-'
      this.modalData.status = rowData[3] ? rowData[3]['values'][0] : '-'
      this.modalData.editAction = true;
    }
  }

}
